// 引入api请求方法
import { post } from '@/api/base'

/** 
 * 
 * @author zxm
 * @update 2019年10月27日
 * */ 

const state = {
    // 接口调用参数
    postParams: {
        name: 1,
        age: 1,
        page:1,
    },
    // 列表data数据
    listData:{
        list:[],
        tableHeadList:[{
            label:'企业名称',
            // list对应表头西安市的字端
            prop:'companyName',
            // table表格一列的宽度
            width:162,
            // 是否显示当前的表头字端
            checked:0,
            // 当前列是否启用排序  false 为显示 true为隐藏
            sortable:false,
            // 当前列 是否显示合计 ** 确保组件开启了 showSummary 属性
            summary:false,
            // 当前列是否距离左边 相对定位
            fixed:true,
            // 动态插入插槽  nf-list 对应写入一个插槽 脚test-content 会对应插入到 table表哥里面
            slotName:'test-content'
        },{
            label:'企业简称',
            prop:'companyShortname',
            width:127,
            checked:1,
        },{
            label:'统一社会信用代码',
            prop:'companyCode',
            width:170,
            checked:1,
        },{
            label:'管理员',
            prop:'administrator',
            width:123,
            checked:1,
        },{
            label:'管理员手机号',
            prop:'administratorPhone',
            width:183,
            checked:1,
        },{
            label:'账号数量',
            prop:'corporationID',
            width:171,
            checked:1,
        },{
            label:'开户时间',
            prop:'corporationID',
            width:160,
            checked:1,
        },{
            label:'开户人',
            prop:'corporationID',
            width:123,
            checked:1,
        }],
        total:0,
    }
}

// getters
const getters = {}

// actions
const actions = {
    // 获取列表数据
    getList: async (context,apiUrl) => {
        // 默认请求地址 是URL地址 例如 /resource/employee/index  跟路由匹配
        let { data } = await post(apiUrl,context.state.postParams)
        context.commit('updateListData',Object.assign({},context.state.listData,data));
    }
}

// mutations
const mutations = {
    // 更新data数据
    updateListData(state, payload) {
        state.listData = payload
    },
    // 更新列表表头数据
    updateEditTableList(state, payload) {
        state.listData.tableHeadList = payload
    },
    // 更新列表参数数据
    updatePostParams(state, payload) {
        state.postParams = Object.assign({},state.postParams,payload)
    },
}

export default {
    namespaced:true,
    state,
    getters,
    actions,
    mutations
}
